// extracted by mini-css-extract-plugin
export default {"white":"#fff","notificationRed":"#ff4c68","primaryIcon":"#309df0","ContestPosts__list":"ss_a bhs_rc bhs_qx bhs_xr","ContestPosts__more":"ss_b bhs_vu bhs_b bhs_va bhs_sv"};